<template>
  <div>
    <section class="page-hero" v-if="isContentLoaded">
      <div class="hero-content d-flex align-items-center justify-content-center">
        <div class="container">
          <h1 class="page-title text-center" v-html="$t('message.accessoriessearch')"></h1>
          <form v-on:submit="submitSearch($event)">
            <div class="row justify-content-center mt-4">
              <div class="col-12 col-md-9 col-lg-6">
                <div class="input-group d-flex">
                  <input type="search" :placeholder="$t('message.findaccessories')" v-model="search">
                  <button class="btn dark" v-html="$t('message.search')"></button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="hero-bg">
        <picture>
          <source media="(max-width: 767.98px)" :srcset="content.acf.mobile_cover.url" />
          <source media="(max-width: 991.98px)" :srcset="content.acf.tablet_cover.url" />
          <img :src="content.acf.desktop_cover.url" :alt="content.acf.desktop_cover.alt" class="d-block">
        </picture>
      </div>
    </section>
    <!-- /.page-hero -->

    <div class="container-fluid py-5">
      <div class="row">
        <!-- Category -->
        <div class="col-3 d-none d-md-block">
          <div class="placeholder" v-if="!isCategoriesLoaded">
            <div class="page-header mb-4" style="width: 30%;"></div>
            <div class="paragraph mb-4" style="width: 50%;" v-for="index in 4" :key="index"></div>
          </div>
          <!-- /.placeholder -->
          <div class="product-category" v-if="isCategoriesLoaded">
            <h2 class="title m-0" v-html="$t('message.categories')"></h2>
            <div class="separate"></div>
            <ul class="nav flex-column category-menu">
              <li class="nav-item">
                <a href="#" :class="['nav-link', categorySelected === '' ? 'active' : '']" @click="getProducts(null, $event)" v-html="$t('message.all')"></a>
              </li>
              <li class="nav-item" v-for="cat in categories" :key="cat.id">
                <a href="#" :class="['nav-link', categorySelected === cat.id ? 'active' : '']" @click="getProducts(cat.id, $event)">{{ cat.name }}</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- /Category -->
        <div class="col-12 col-md-9">
          <div class="row placeholder" v-if="!isProductsLoaded">
            <div class="col-12 col-md-6 col-lg-4" v-for="index in 3" :key="index">
              <div class="product-card">
                <div class="product-thumbnail"></div>
                <div class="product-name mb-2" style="width: 40%;"></div>
                <div class="product-name" style="width: 60%;"></div>
              </div>
            </div>
          </div>
          <!-- /.placeholder -->
          <div class="row" v-if="isProductsLoaded">
            <div class="col-12 col-md-6 col-lg-4" v-for="product in products" :key="product.id">
              <div class="product-card">
                <router-link :to="{ name: product.type, params: { slug: product.slug } }">
                  <div class="product-thumbnail">
                    <div class="product-media" v-lazy-container="{ selector: 'img' }">
                      <img :data-src="product._embedded['wp:featuredmedia'][0].media_details.sizes['post-thumbnail'].source_url" class="img-fluid" :alt="product._embedded['wp:featuredmedia'][0].alt_text">
                    </div>
                  </div>
                  <div class="product-detail">
                    <div class="product-title" v-html="product.title.rendered"></div>
                    <div class="product-desc" v-html="product.excerpt.rendered"></div>
                  </div>
                </router-link>
              </div>
              <!-- /.product-card -->
            </div>
          </div>
          <div class="row" v-if="isProductsLoaded && !products.length">
            <div class="col-12 text-center" v-html="$t('message.noproduct')"></div>
          </div>
          <!-- /.row is empty -->
        </div>
      </div>
    </div>
    <!-- /.continer -->
  </div>
</template>

<script>
import axios from 'axios'
import '@/assets/sass/product.sass'
export default {
  name: 'AccessoriesLanding',
  data () {
    return {
      api_path: process.env.VUE_APP_API_PATH,
      title: process.env.VUE_APP_TITLE,
      content: [],
      isContentLoaded: false,
      products: [],
      isProductsLoaded: false,
      categories: [],
      isCategoriesLoaded: false,
      search: '',
      categorySelected: ''
    }
  },
  mounted () {
    const cat = this.$router.history.current.query.cat
    this.getContent()
    this.getProducts(cat)
    this.getCategories()
  },
  methods: {
    getContent () {
      const lang = this.$route.params.lang
      axios.get(`${this.api_path}wp-json/wp/v2/pages`, {
        params: {
          slug: 'accessories',
          lang
        }
      })
        .then(res => {
          this.content = res.data[0]
          this.isContentLoaded = true
          document.title = `${this.content.title.rendered} - ${this.title}`
        })
    },
    getProducts (category = null, e = null) {
      const $vm = this
      const lang = this.$route.params.lang
      if (e) {
        e.preventDefault()
      }
      if (category) {
        $vm.categorySelected = parseInt(category)
        $vm.$router.replace({ name: 'AccessoriesLanding', query: { cat: category } })
      } else {
        $vm.categorySelected = ''
        $vm.$router.replace({ name: 'AccessoriesLanding' })
      }
      $vm.isProductsLoaded = false
      axios.get(`${this.api_path}wp-json/wp/v2/accessories`, {
        params: {
          _embed: true,
          search: $vm.search,
          'accessory-category': category,
          lang
        }
      })
        .then(res => {
          if (res.data) {
            $vm.products = res.data
            $vm.isProductsLoaded = true
          }
        })
    },
    getCategories () {
      const $vm = this
      const lang = this.$route.params.lang
      $vm.isCategoriesLoaded = false
      axios.get(`${this.api_path}wp-json/wp/v2/accessory-category`, {
        params: {
          lang
        }
      })
        .then(res => {
          if (res.data) {
            $vm.isCategoriesLoaded = true
            $vm.categories = res.data
          }
        })
    },
    submitSearch (e) {
      e.preventDefault()
      this.getProducts()
    }
  }
}
</script>
